<template>
  <div>
    <h4 class="q-mb-xs text-weight-medium text-grey-10">
      {{ label }}
    </h4>
    <span class="text-tab" v-if="lastUpdated">
      Last Updated Date: {{ lastUpdated }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TermsHeader',
  props: {
    lastUpdated: String,
    label: {
      type: String,
      required: true
    }
  }
};
</script>
